import { useActivePlotGroup } from '@/components/PlotGroups/PlotGroupsContextProvider';
import { isNullish } from '@/utils/booleans';

export const usePlotGroupFilterEndYear = () => {
  const { filters } = useActivePlotGroup();
  return !isNullish(filters?.end_date);
};
